import { render } from "./head.vue?vue&type=template&id=5c4d1028&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=5c4d1028&lang=scss"
import "./head.vue?vue&type=style&index=1&id=5c4d1028&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4d1028"]])

export default __exports__